"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.APFormFieldDateTime = void 0;
var moment_1 = __importDefault(require("@date-io/moment"));
var DateRange_1 = __importDefault(require("@material-ui/icons/DateRange"));
var Schedule_1 = __importDefault(require("@material-ui/icons/Schedule"));
var pickers_1 = require("@material-ui/pickers");
var moment_2 = __importDefault(require("moment"));
var react_1 = __importStar(require("react"));
var APForm_1 = require("./APForm");
function APFormFieldDateTime(_a) {
    var _this = this;
    var _b = _a.margin, margin = _b === void 0 ? "normal" : _b, _c = _a.label, label = _c === void 0 ? "Date" : _c, _d = _a.formatter, formatter = _d === void 0 ? "DD/MM/YYYY hh:mm a" : _d, style = _a.style, size = _a.size, placeholder = _a.placeholder, initialValue = _a.initialValue, value = _a.value, readOnly = _a.readOnly, helperText = _a.helperText, onChanged = _a.onChanged, validator = _a.validator, control = _a.control, disabled = _a.disabled;
    var control2 = react_1.useContext(APForm_1.APFormContext);
    if (control !== undefined) {
        control2 = control;
    }
    var tempValue = initialValue !== null && initialValue !== void 0 ? initialValue : value;
    var _e = react_1.useState(tempValue ? moment_2.default(tempValue) : null), _value = _e[0], setValue = _e[1];
    var _f = react_1.useState(null), error = _f[0], setError = _f[1];
    function checkValues() {
        return __awaiter(this, void 0, void 0, function () {
            var errorMessage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        errorMessage = null;
                        if (!validator) return [3 /*break*/, 2];
                        return [4 /*yield*/, validator(_value)];
                    case 1:
                        errorMessage = _a.sent();
                        _a.label = 2;
                    case 2:
                        setError(errorMessage);
                        return [2 /*return*/, !errorMessage];
                }
            });
        });
    }
    var fieldItem = {
        validate: checkValues,
        reset: function () {
            setValue(initialValue ? moment_2.default(initialValue) : null);
        }
    };
    react_1.useEffect(function () {
        control2 && control2.fields.add(fieldItem);
        return function () {
            control2 && control2.fields.delete(fieldItem);
        };
    });
    react_1.useEffect(function () {
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = validator && error;
                        if (!_a) return [3 /*break*/, 2];
                        _b = setError;
                        return [4 /*yield*/, validator(_value)];
                    case 1:
                        _a = _b.apply(void 0, [_c.sent()]);
                        _c.label = 2;
                    case 2:
                        _a;
                        onChanged && onChanged(_value);
                        return [2 /*return*/];
                }
            });
        }); })();
    }, [_value]);
    return (react_1.default.createElement(pickers_1.MuiPickersUtilsProvider, { utils: moment_1.default },
        react_1.default.createElement(pickers_1.KeyboardDateTimePicker, { label: label, style: style, size: size, disabled: disabled, readOnly: readOnly, placeholder: placeholder, margin: margin, timeIcon: react_1.default.createElement(Schedule_1.default, { htmlColor: "white" }), dateRangeIcon: react_1.default.createElement(DateRange_1.default, { htmlColor: "white" }), inputVariant: "outlined", value: _value ? moment_2.default(_value) : null, helperText: error || helperText, format: formatter, error: !!error, onChange: function (date) {
                if (date)
                    setValue(date);
            } })));
}
exports.APFormFieldDateTime = APFormFieldDateTime;
